const types = [
  {value:1,label:"Transfer In"},
  {value:2,label:"Pembelian"},
]
const statuses = [
  {value:"",label:"Semua Status"},
  {value:"1",label:"Pembelian"},
  {value:"2",label:"Transfer Keluar"},
  {value:"3",label:"Transfer Sebagian"},
  {value:"4",label:"Penerimaan"},
  {value:"5",label:"Penerimaan Sebagian"},
]
const detailDefault = {
  id_items: null,
  item_name: "",
  qty: 1,
  id_unit: null,
  name_unit: "",
  note: ""
}

export default {
  types,
  statuses,
  detailDefault
}